/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderItem
 */
export interface OrderItem {
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    column?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItem
     */
    asc?: boolean;
}

/**
 * Check if a given object implements the OrderItem interface.
 */
export function instanceOfOrderItem(value: object): value is OrderItem {
    return true;
}

export function OrderItemFromJSON(json: any): OrderItem {
    return OrderItemFromJSONTyped(json, false);
}

export function OrderItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItem {
    if (json == null) {
        return json;
    }
    return {
        
        'column': json['column'] == null ? undefined : json['column'],
        'asc': json['asc'] == null ? undefined : json['asc'],
    };
}

export function OrderItemToJSON(json: any): OrderItem {
    return OrderItemToJSONTyped(json, false);
}

export function OrderItemToJSONTyped(value?: OrderItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'column': value['column'],
        'asc': value['asc'],
    };
}

